// SVG path data extracted from Font Awesome 6 Pro Solid (used by claire-dashboard),
// so the icons here match the StatusIcon component there 1:1 despite this project
// being pinned to Font Awesome 5.

export const faSquareA = {
  prefix: "fas",
  iconName: "square-a",
  icon: [
    448,
    512,
    [],
    "e25f",
    "M64 32Q37 33 19 51L19 51Q1 69 0 96L0 416Q1 443 19 461Q37 479 64 480L384 480Q411 479 429 461Q447 443 448 416L448 96Q447 69 429 51Q411 33 384 32L64 32ZM224 128Q239 129 246 141L350 349Q357 370 339 382Q318 389 307 371L289 336L159 336L141 371Q130 389 109 381Q90 370 99 349L203 141Q210 128 224 128ZM224 206L183 288L265 288L224 206Z",
  ],
};

export const faCarMirrors = {
  prefix: "fas",
  iconName: "car-mirrors",
  icon: [
    576,
    512,
    [],
    "e343",
    "M167 117Q175 97 197 96L379 96Q401 97 409 117L435 192L141 192L167 117ZM32 224L41 224Q32 238 32 256L32 400L32 448Q32 462 41 471Q50 480 64 480L96 480Q110 480 119 471Q128 462 128 448L128 400L448 400L448 448Q448 462 457 471Q466 480 480 480L512 480Q526 480 535 471Q544 462 544 448L544 400L544 256Q544 238 535 224L544 224Q558 224 567 215Q576 206 576 192Q576 178 567 169Q558 160 544 160L492 160L469 96Q459 67 434 50Q410 32 379 32L197 32Q166 32 142 50Q117 67 107 96L85 160L32 160Q18 160 9 169Q0 178 0 192Q0 206 9 215Q18 224 32 224ZM96 288Q96 274 105 265L105 265Q114 256 128 256Q142 256 151 265Q160 274 160 288Q160 302 151 311Q142 320 128 320Q114 320 105 311Q96 302 96 288ZM448 256Q462 256 471 265L471 265Q480 274 480 288Q480 302 471 311Q462 320 448 320Q434 320 425 311Q416 302 416 288Q416 274 425 265Q434 256 448 256Z",
  ],
};

export const faCircleQuarterStroke = {
  prefix: "fas",
  iconName: "circle-quarter-stroke",
  icon: [
    512,
    512,
    [],
    "e5d3",
    "M64 256L224 256Q238 256 247 247Q256 238 256 224L256 64Q338 66 392 120Q446 174 448 256Q446 338 392 392Q338 446 256 448Q174 446 120 392Q66 338 64 256ZM0 256Q1 326 34 384L34 384Q68 442 128 478Q189 512 256 512Q323 512 384 478Q444 442 478 384Q511 326 512 256Q511 186 478 128Q444 70 384 34Q323 0 256 0Q189 0 128 34Q68 70 34 128Q1 186 0 256Z",
  ],
};
